module.exports = __webpack_public_path__ + "04_very_short_yellow.c6b03845.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_very_short_yellow.png
// module id = RYW8
// module chunks = 0